import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BestSpreadsheet2026 from "../pages/article/BestSpreadsheet2026";
import HowToUseSpreadsheet from "../pages/article/HowToUseSpreadsheet";
import VsPandabuy from "../pages/article/VsPandabuy";
import BestSneakerSpreadsheet from "../pages/article/BestSneakerSpreadsheet";
import DesignerBrandsSpreadsheet from "../pages/article/DesignerBrandsSpreadsheet";
import CheapFinds from "../pages/article/CheapFinds";
import StreetwearGuide from "../pages/article/StreetwearGuide";
import ShippingGuide from "../pages/article/ShippingGuide";
import TopCategories from "../pages/article/TopCategories";
import BeginnersGuide from "../pages/article/BeginnersGuide";
import BudgetClothing from "../pages/article/BudgetClothing";
import LuxurySpreadsheet from "../pages/article/LuxurySpreadsheet";
import HiddenGems from "../pages/article/HiddenGems";
import UpdatedWeekly from "../pages/article/UpdatedWeekly";
import UltimateResource from "../pages/article/UltimateResource";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/best-sugargoo-spreadsheet-2026",
    element: <BestSpreadsheet2026 />,
  },
  {
    path: "/article/how-to-use-sugargoo-spreadsheet",
    element: <HowToUseSpreadsheet />,
  },
  {
    path: "/article/sugargoo-spreadsheet-vs-pandabuy",
    element: <VsPandabuy />,
  },
  {
    path: "/article/best-sneaker-sugargoo-spreadsheet",
    element: <BestSneakerSpreadsheet />,
  },
  {
    path: "/article/designer-brands-sugargoo-spreadsheet",
    element: <DesignerBrandsSpreadsheet />,
  },
  {
    path: "/article/cheap-sugargoo-spreadsheet-finds",
    element: <CheapFinds />,
  },
  {
    path: "/article/streetwear-sugargoo-spreadsheet-guide",
    element: <StreetwearGuide />,
  },
  {
    path: "/article/sugargoo-shipping-guide",
    element: <ShippingGuide />,
  },
  {
    path: "/article/top-sugargoo-spreadsheet-categories",
    element: <TopCategories />,
  },
  {
    path: "/article/sugargoo-spreadsheet-for-beginners",
    element: <BeginnersGuide />,
  },
  {
    path: "/article/budget-clothing-spreadsheet",
    element: <BudgetClothing />,
  },
  {
    path: "/article/luxury-spreadsheet-guide",
    element: <LuxurySpreadsheet />,
  },
  {
    path: "/article/hidden-gems-sugargoo-spreadsheet",
    element: <HiddenGems />,
  },
  {
    path: "/article/updated-sugargoo-spreadsheet-weekly",
    element: <UpdatedWeekly />,
  },
  {
    path: "/article/ultimate-sugargoo-spreadsheet-resource",
    element: <UltimateResource />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;